// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3A_aZ","inner":"Footer_inner__14vcb","nextIcon":"Footer_nextIcon__2aDPM","innerLeft":"Footer_innerLeft__1r_34"};